import "react-app-polyfill/ie11";
import "core-js/stable"; // Polyfill
import "regenerator-runtime/runtime"; // Polyfill
import cssVars from "css-vars-ponyfill";
import { enableES5 } from "immer";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { supportsShadowDOM } from "lib/shadowDOM";
import { VERSION, WIDGET_REACT_ID, WIDGET_MODES, BRANDS } from "config";
import configureApp from "configureApp";
import "index.css";
import App from "App";

const mode = document.getElementById(WIDGET_REACT_ID) !== null
  ? WIDGET_MODES.IFRAME
  : WIDGET_MODES.SCRIPT;

cssVars({ updateURLs: false, watch: true }); // Ponyfill for IE 11
enableES5();

const addStylesheet = (stylesheetUrl, brand = '') => {
  const link = document.createElement('link');
  const hostname = window !== undefined ? window.location.hostname : '';
  const isDev = process.env.NODE_ENV === 'development' && hostname === 'localhost';
  const brandFullName = BRANDS[brand] ?? '';
  const isStylesheetUrlValid = !!stylesheetUrl && stylesheetUrl !== 'null';

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = isDev && brandFullName && !isStylesheetUrlValid ? `brands/${brandFullName}.css` : stylesheetUrl;
  document.head.appendChild(link);
};

const buildApp = async (scriptArgs = null) => {
  const appConfig = await configureApp(mode, scriptArgs);
  const { rootElement, stylesheetUrl, brand } = appConfig;

  let target = rootElement;
  if (supportsShadowDOM()) {
    rootElement.attachShadow({ mode: "open" });
    target = rootElement.shadowRoot;
  }

  cssVars({ updateURLs: false, watch: true }); // Ponyfill for IE 11
  enableES5();

  stylesheetUrl && addStylesheet(stylesheetUrl, brand);

  console.log(`OTRL JP Widget\n--------------\nVersion: ${VERSION}`);

  ReactDOM.render(
    <React.StrictMode>
      <App {...appConfig} />
    </React.StrictMode>,
    target
  );
};


// ENTRY POINT
mode === WIDGET_MODES.IFRAME
  ? buildApp()
  : window.OtrlJPWidget = { init: scriptArgs => buildApp(scriptArgs) };


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
